<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 px-4">
    <div class="max-w-lg w-full">
      <div class="bg-white rounded-lg shadow-lg text-center py-12 px-6">
        <div class="text-9xl font-bold text-gray-800">
          4<span class="text-primary-600">0</span>4
        </div>

        <div class="text-2xl font-semibold text-gray-800 mt-6">
          Error - Page Not Found
        </div>

        <div class="border-t border-gray-200 my-6"></div>

        <div class="text-lg text-gray-600 mt-4">
          Please check the URL.
        </div>

        <div class="text-lg text-gray-600 mt-2 mb-8">
          Otherwise,
          <router-link
            class="text-primary-600 hover:text-primary-700 font-medium no-underline"
            :to="{ name: 'login' }"
          >
            click here
          </router-link>
          to go to home page.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error404"
};
</script>

